import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { GetCodeListResponse } from './get-code-list.service';

// レスポンス構造
export type GetOrderListResponse = {
  OrderCode: string;
  CatalogID: string;
  RegistCycle: string;
}[];

/**
 * 受注コード一覧取得サービス
 * @export GetOrderListService
 * @class GetOrderListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOrderListService extends PlessJsonResponderSub<GetOrderListResponse> {
  private storeObj: object; // 格納先オブジェクト
  private storeParam: string; // 格納先属性名
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOrderListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param obj 格納先オブジェクト
   * @param param 格納先属性名
   * @param f コールバック
   * @memberof GetOrderListService
   */
  execute(
    obj: object,
    param: string,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.storeObj = obj;
    this.storeParam = param;
    this.succeed = s;
    this.fail = f;
    this.send('KYMW02getOrderList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOrderListService
   */
  success(data: GetOrderListResponse) {
    if (this.storeParam in this.storeObj) this.storeObj[this.storeParam] = data;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param codeDiv
   * @param reserveNum
   * @returns Promise<void>
   */
  public executeAsync(obj: object, param: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        obj,
        param,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
